
import { motion } from 'framer-motion';

const SocialProofBanner = () => {
  const testimonials = [
    { name: 'Sarah Johnson', text: 'Transformed my e-commerce business completely!' },
    { name: 'Michael Chen', text: 'Best business consultant I have worked with' },
    { name: 'Amara Obi', text: 'My wellness journey started here and I feel amazing' },
    { name: 'David Williams', text: 'Increased my revenue by 300% in 6 months' },
    { name: 'Fatima Abdullah', text: 'Professional, knowledgeable, and truly caring' },
  ];

  const duplicatedTestimonials = [...testimonials, ...testimonials, ...testimonials];

  return (
    <section className="py-8 bg-accent-light-sage overflow-hidden">
      <motion.div
        animate={{ x: ['0%', '-33.33%'] }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: 'linear',
        }}
        className="flex items-center space-x-12 whitespace-nowrap"
      >
        {duplicatedTestimonials.map((testimonial, index) => (
          <div key={index} className="flex items-center space-x-12">
            <div className="flex items-center space-x-4">
              <div className="flex space-x-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-gold text-sm"></i>
                ))}
              </div>
              <span className="text-primary-charcoal font-medium">{testimonial.text}</span>
              <span className="text-gray-500 text-sm">— {testimonial.name}</span>
            </div>
            <span className="text-primary-sage text-2xl">•</span>
          </div>
        ))}
      </motion.div>
    </section>
  );
};

export default SocialProofBanner;
